import React from "react";

export default function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6" data-testid={testid}>
      <div>
        {eyebrow && (
          <div className="text-[10px] font-semibold uppercase tracking-[0.28em] text-blue-800 mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900 tracking-tight">
          {title}
        </h1>
        {description && (
          <p className="text-slate-500 mt-2 max-w-2xl text-sm md:text-[15px]">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
